/* eslint-disable max-lines */
/* eslint-disable max-len */

export default {
  lang: 'ko',
  homeScreen: {
    title: '',
    stayConnected: '소식 듣기',
    comingSoon: '곧 공개',
    downloadNow: '지금 다운로드:',
    readMore: '더 읽기 ',
  },
  glassWidgets: {
    errors: {
      requestFailed: '문제가 발생했습니다. 나중에 다시 시도해 주세요.',
    },
    programStatus: {
      title: '내 상태',
      loading: '로딩 중…',
      yourRep: '담당자',
      myProfile: '프로필',
      favorites: '즐겨찾기',
      registeredOn: '가입일:',
      graduatedOn: '수료일:',
      totalBadgesEarned: '획득한 총 배지 수:',
      lastBookingLogged: '마지막 예약 기록:',
      currentTier: '현재 등급',
      lastBadgeEarned: '마지막 획득 배지:',
      currentFocus: '현재 포커스:',
    },
    todaysfocus: {
      title: '오늘의 포커스',
      empty: '오늘의 포커스 항목이 없습니다',
      loading: '로딩 중…',
      error: '문제가 발생했습니다',
      slideNavAria: '슬라이드 탐색',
      slideAria: '슬라이드',
      carouselAria: '오늘의 포커스',
    },
    welcome: '환영합니다!',
    welcomeBack: '다시 오신 것을 환영합니다, {firstName}님!',
    notifications: {
      loading: '로딩 중…',
      empty: '알림이 없습니다',
    },
    achievements: {
      title: '리워드 및 콘테스트',
      loading: '로딩 중…',
      lastBooking: '최근 제출 항목',
      currentTier: '현재 등급',
      contestEntries: '총 콘테스트 참여 수',
      nightsBooked: '예약된 숙박일 수',
      totalRevenue: '보고된 총 매출',
      noBookingData: '예약 데이터가 없습니다.',
      fileUploadSuccess: '파일이 성공적으로 업로드되었습니다.',
      quickSubmit: {
        title: '빠른 제출',
        uploading: '업로드 중…',
        clear: '지우기',
        submit: '제출',
        submitSuccessSimulated: '예약이 성공적으로 제출되었습니다',
      },
    },
  },
  profileImageView: {
    currentImage: '현재 프로필 이미지:',
    uploadImage: '프로필 이미지 업로드:',
    chooseAFile: '파일 선택…',
    cancel: '취소',
    backButton: '뒤로 가기',
    uploadButton: '프로필 이미지 업로드',
    saveButton: '이 프로필 이미지 저장',
    fileTooLargeTitle: '업로드 크기 초과',
    fileTooLargeText: '최대 이미지 업로드 크기는 10MB입니다',
  },
  notification: {
    newAndNow: '새소식 & 지금!',
    alert: '알림',
    message: '메시지',
    badge: '새 배지',
    contest: '콘테스트',
    'content-update': '콘텐츠 업데이트',
    events: '이벤트',
    other: '알림',
    welcome: '환영합니다',
  },
  sharing: {
    email: '이메일',
    download: '다운로드',
    copyURL: '링크 복사',
    copied: '복사:',
    shareSubjectBadge: '미국 전문가 배지',
  },
  shareSubjectDiploma: '미국 전문가 학위:',
  loginScreen: {
    version2: {
      accountCreated: '계정이 생성되었습니다. 프로세스를 완료하려면 이메일을 확인하세요.',
      homeTitle: '저희 시스템 안에서 기존 프로필을 찾을 수 있는지 살펴보겠습니다.',
      homeTitleSub: '트레이닝 프로그램에 로그인하기 위해 평소 사용하는 이메일 주소를 입력해주세요.',
      noAccount: '계정을 찾을 수 없습니다({email}). 새로운 이메일을 시도하거나 계정을 지금 새로 생성하세요.',
      continueButton: '계속',
      success: '계정을 성공적으로 업데이트했습니다! 곧 홈페이지로 리디렉션됩니다.',
      successNewAccount: '가입을 완료하기 위해, 계정을 인증하는 확인 이메일을 받게 됩니다.',
      loginButton: '로그인',
      matchFound: '일치하는 항목이 있습니다. 계속하려면 비밀번호를 입력하세요.',
      magicLink: '이메일 링크로 로그인:',
      magicLinkButton: '매직 링크 요청',
      magicLinkTitle: '즉시 로그인되는 다이렉트 링크를 이메일에서 확인하세요.',
      otherEmailButton: '제출',
      title: '잠시 시간을 내어 아래 정보를 모두 채워주시면 개인 프로필과 연락처 정보가 입력됩니다.',
      titleIndustry: '잠시 시간을 내어 아래 정보를 모두 채워주시면 개인 프로필과 연락처 정보가 입력됩니다.',
      register: '계정 만들기',
      agent: '여행사 직원',
      visitor: '업계 방문객',
      step1: '1단계: 사용자 유형',
      step2: '2단계: 계정 만들기',
      step3: '3단계: 계정 생성',
      marketingOptIn: '정말로 이 프로그램의 관광 사업 팀의 소식에 관심이 없으신가요?',
      optIn: '관심 있음',
      optOut: '관심 없음',
      step2Sub1: '여러분에 대해 알려주세요.',
      step2Sub2: '비즈니스에 대해 알려주세요.',
      privacyHead: '커뮤니케이션 설정',
      privacySub:
        '공급업체의 관광 사업 팀에 대한 중요 커뮤니케이션(제품 업데이트 및 발표, 리워드, 인센티브, 팸(FAM) 투어 등)을 수신하고 TravPRO Mobile에서 관광 사업 네트워킹과 영업 지원 이니셔티브를 받아보려면 아래 박스에 체크 표시를 해주세요.',
      privacy: '당사는 여러분의 프라이버시를 보호하며 이를 판매하거나 오용하여 신뢰에 반하는 행동을 하지 않습니다.',
      store: '사용하시는 앱스토어에서 이 프로그램을 편하게 다운로드하세요.',
      powered: 'POWERED BY',
      toastMessage: {
        forgotSuccess: '비밀번호 재설정 링크를 이메일로 보내드렸습니다! 10초 후에 로그인 페이지로 리디렉션됩니다.',
        emailNotExisting: '입력하신 이메일 주소가 존재하지 않습니다.',
        magicLinkMessage: '잠시 기다려주세요. 지금 로그인 중입니다.',
        magicLinkError: '데이터베이스에서 계정을 찾을 수 없습니다. 직접 로그인하세요. 10초 후에 리디렉션됩니다.',
        magicLinkError1:
          '유효한 토큰을 찾을 수 없습니다. 로그인하거나 새로운 매직 링크를 요청해주세요. 문제가 계속되는 경우 info@travpromobile.com으로로 문의해 주시기 바랍니다.',
        magicLinkError2: '데이터베이스에서 계정을 찾을 수 없습니다. 직접 로그인하세요. 10초 후에 리디렉션됩니다.',
        magicLinkSuccess: '{email}에서 이메일을 확인하세요. 로그인할 수 있는 매직 링크가 있습니다.',
        magicLinkErrorWait: '매직 링크 요청은 5분 간격을 두고 해주시기 바랍니다.',
        emailNotFoundError:
          '입력하신 이메일 주소를 기록에서 찾을 수 없습니다. 오타가 없는지 확인하거나 새로운 계정을 생성하세요.',
      },
      errors: {
        zipCodeNotFound: '우편번호를 찾을 수 없습니다. 다시 시도하세요.',
        zipCodeOnlyNumbers: '우편번호는 숫자만 입력 가능합니다.',
        password: '비밀번호를 입력하세요.',
        passwordNotMatching: '입력하신 비밀번호가 일치하지 않습니다.',
        passwordTooShort: '비밀번호는 최소 8자여야 합니다.',
        emailExists:
          '이 이메일 주소를 이미 사용 중이거나 유효하지 않습니다. 다른 이메일 주소로 시도하거나 계정에 로그인하세요.',
        fillInAllFields: '필수 입력 사항을 모두 입력하세요.',
        fillInEmail: '이메일 주소를 입력하세요.',
        emailNotExisting: '입력하신 이메일 주소가 존재하지 않습니다.',
      },
      fields: {
        forgotSubCopy: '비밀번호를 잊어서 변경하고 싶으신가요? ',
        forgotSubCopy2:
          '비밀번호 입력을 완전히 우회하고 싶으신가요? 프로그램에 자동으로 로그인할 수 있도록 매직 링크가 포함된 이메일을 전송해드리겠습니다. ',
        city: '도시',
        companyName: '회사명',
        role: '직책(1개를 선택해 주세요)',
        description: '다음 중 귀하의 비즈니스를 가장 잘 설명하는 것은 무엇입니까?',
        country: '국가',
        password: '비밀번호',
        passwordRegister: '비밀번호 선택(최소 8자)',
        passwordConfirm: '비밀번호 확인',
        firstName: '이름',
        lastName: '성',
        agency: '여행사명',
        title: '직책(1개를 선택해 주세요)',
        company: '회사명',
        select: '아래에서 선택',
        state: '주',
        province: '도/지역/주',
        zipCode: '우편 번호(미국)',
        postalCode: '우편 번호',
        affiliate: '주요 소속 여행사는 어디입니까?',
        hostAgency: '호스트 여행사를 말씀해 주세요.',
        executive: '경영',
        management: '관리',
        marketing: '마케팅',
        sales: '영업',
        coordinator: '코디네이터',
        opt: '브랜드 미국 팀과 연결 상태를 유지하고 미국 디스커버리 프로그램 업데이트를 받으십시오.',
        optMarketing: '추가 학습 프로그램에 대한 소식을 들으려면 TravPRO에 계속 연결하세요.',
        retail: '소매점 프론트 오피스',
        home: '자택 기반',
        independent: '프리랜서',
        host: '호스트 여행사',
        call: '콜센터 또는 웹 기반 여행사',
        other: '기타 ',
        describes: '귀하와 여행사의 비즈니스를 가장 잘 설명하는 것은 무엇입니까? ',
      },
    },
    title: '여행 전문 트레이닝 및 영업 지원 프로그램',
    welcome: {
      headerTop: '환영합니다!',
      headerBottom: 'USA 디스커버리 프로그램입니다.',
    },
    sellingPoints: {
      0: '이동 중에도 배우고, 홍보하고, 영업하세요.',
      1: '다양한 기기에 걸쳐 멀티 미디어 트레이닝 가능',
      2: '완료 인증서 제공',
      3: '체험 및 파트너 배지 제공',
      4: '공유 가능한 홍보 자료',
      5: '24시간 영업 리소스 사용 가능',
      6: '트레이닝 보상',
      7: '인센티브 및 메가 팸(MegaFam) 투어',
    },
    tAndC: {
      agree: '계속하면 다음에 동의하시게 됩니다. ',
      privacyPolicy: '개인정보 보호정책',
      and: ' 및 ',
      termsConditions: '이용 약관',
    },
    fields: {
      select: '아래에서 선택',
      country: '국가',
      agency: '여행사',
      email: '이메일',
      password: '비밀번호',
      passwordConfirm: '비밀번호 확인',
      firstName: '이름',
      lastName: '성',
      address: '주소',
      postalCode: '우편 번호(미국)',
      city: '도시',
      agencyName: '여행사명',
      stateProvince: '주/도',
      required: '필수 입력 항목',
      invalidEmail: '유효하지 않은 이메일 주소',
      opt: '소식을 계속 받아보세요! 네, Brand USA의 커뮤니케이션을 통해 뉴스, 이벤트, 인센티브, 팸 투어 등 다양한 소식을 계속해서 받아 볼게요!',
      forgot: '비밀번호를 잊으셨나요? 아래의 버튼을 클릭하시면 비밀번호를 재설정할 수 있는 이메일을 보내드립니다.',
    },
    forgot: '비밀번호 재설정',
    noAgent: {
      noAgentButton: '에이전트가 아닙니다',
      title: 'USA 디스커버리 프로그램에 관심을 가져 주셔서 감사합니다.',
      messageWeb:
        '이 사이트의 콘텐츠는 여행 전문가들에게만 독점적으로 공개됩니다. \n Brand USA에 대해 더 자세히 알아보려면 다음을 방문하세요. ',
      messageMobile:
        "이 앱의 일부 콘텐츠는 여행 전문가들에게만 독점적으로 공개됩니다. 하지만 '계속'을 눌러 이 앱이 제공하는 정보의 미리 보기를 둘러볼 수 있습니다.",
      continue: '계속',
      visitWebsite: '웹사이트 방문',
    },
    newUser: '새로운 사용자',
    register: '가입',
    registered: '이미 가입된 이메일입니다.',
  },
  welcomeScreen: {
    title: 'USA 디스커버리 프로그램에 오신 것을 환영합니다.',
    helloUser: '{{name}} 님, 안녕하세요.',
    hello: '안녕하세요,',
    fromAgency: '{{agency}} 소속 회원님.',
    notUser: '{{name}}님이 아니신가요?',
    startTraining: '교육 시작하기',
    continueTraining: '교육 계속하기',
    graduated: '축하합니다!',
    downloader: {
      stop: '정지',
      init: '초기화 중...',
      lastUpdate: '마지막 업데이트: ',
    },
  },
  trainingScreens: {
    comingSoon: '곧 공개: {title}',
    categoryLockMinimum: '이 카테고리에 접근하려면 트레이닝을 포함해 최소 {number}개를 잠금 해제하세요.',
    allUnlocked: '모든 챕터를 잠금 해제하셨습니다!',
    completedBase: '축하합니다. 이제 공인된 미국 전문가가 되었습니다!',
    certificate: '인증서',
    chapter: '챕터',
    chapterComplete: '챕터 완료!',
    choose: '답변을 선택해 주세요.',
    confirm: '답변을 확인해 주세요.',
    continue: '계속',
    courseComplete: '과정을 완료하셨네요!',
    durationInMinutes: '{number}분',
    endReached: '끝입니다.',
    essential: '기초',
    essentialSub: '필수 챕터를 완료해 학위를 받고 아래의 특화 분야를 잠금 해제하세요.',
    message: '{count}건의 메시지',
    messagePlural: '{count}건의 메시지',
    percentageComplete: '{number}% 완료',
    restart: '복습하기',
    review: '복습하기',
    retainEnd: '상단의 바를 사용해 이 챕터 곳곳으로 이동하거나 뒤로 버튼을 눌러 개요로 돌아가세요.',
    retry: '다시 시도',
    skip: '돌아가기 >',
    viewAllTitle: '트레이닝 팁',
    badge: '배지 다운로드',
    viewAll:
      '다음 페이지로 넘어가기에 앞서, 잠시 시간을 내어 아이콘을 포함한 모든 콘텐츠를 복습하세요. 여러분이 전문가가 되는 데 필요한 추가 정보를 제공해드립니다.',
    start: '시작',
    status: '현재 상태:',
    trouble: '문제가 있으신 것 같습니다. 이전 페이지의 콘텐츠를 다시 읽으신 다음 다시 시도하세요.',
    unlockDefault: '이전 챕터를 완료해 이 챕터를 잠금 해제하세요.',
    unlock: '트레이닝 챕터를 완료해 이 챕터를 잠금 해제하세요.',
    unlockSubtitle: '트레이닝 챕터를 완료해 더 많은 챕터를 잠금 해제하세요.',
    unlockFoundation: '기초를 완료해 이 챕터를 잠금 해제하세요.',
    watchListenRead: '더 많이 보고, 듣고, 읽으세요',
    completed: '완료',
  },
  trainingExtraScreens: {
    subtitle: '경험',
    error: '죄송합니다. 문제가 발생했습니다.',
    uncompletedTitle: '{partner} 경험 완료되지 않음',
    completedTitle: '{partner} 경험 완료함',
    noAvailableBadges: '사용 가능한 배지가 아직 없습니다.',
    interimScore: '완료',
    interimScoreEnd: '배지를 얻으려면 몇 챕터 더 남았습니다.',
    badgesComplete: '축하합니다! 다음의 배지를 얻으셨습니다.',
  },
  newTrainingFlow: {
    partnerModules: '파트너 특화 영역',
    finishGold: '이 챕터를 완료해 파트너에 대해 더 알아보고 배지를 받아보세요.',
  },
  points: {
    complete: {
      chapter: '챕터 완료!',
      'intro-chapter': '소개 챕터를 완료하셨습니다!',
      'sub-app': 'SubApp를 완료하셨습니다!',
      rewards: '리워드를 완료하셨습니다!',
    },
    completed: '{completed} 배지 획득',
  },
  nav: {
    home: '홈',
    train: '트레이닝',
    learn: '트레이닝',
    retain: '유지',
    promote: '홍보',
    sell: '판매',
    info: '정보',
    rewards: '리워드',
    media: '미디어',
    favorites: '즐겨찾기',
    contact: '소식 받기',
    diploma: '학위',
    accountSettings: '계정 설정',
    messages: '메시지',
    search: '검색',
    showcases: '쇼케이스',
  },
  contentHeaders: {
    subapps: '파트너 특화 영역',
    maintrainings: '지역',
    subtrainings: '경험',
    itineraries: '여행 일정',
  },
  pageDescriptions: {
    train: '교육을 받고 소통하여 전문가가 되어보세요.',
    retain: '사용하기 쉬운 이 콘텐츠 리소스로 여러분의 전문 지식을 유지해 보세요.',
    promote: '이 아이템을 사용해 클라이언트 및 잠재 고객의 흥미를 유발하고 대화를 시작해 보세요.',
    sell: '클라이언트의 질문에 답하고 Brand USA와 소통하세요.',
    favorites: '나의 즐겨찾기 콘텐츠.',
    search: '모든 콘텐츠 보기',
    subapps: '이 챕터를 완료해 파트너에 대해 더 알아보고 배지를 받아보세요.',
    subtrainings: '나의 전문 지식을 향상하고 아래 각 섹션에서 배지를 받아보세요.',
    itineraries: '인기 있는 로드 트립에 관한 이 짧은 챕터들을 모두 완료하고, 각 챕터마다 배지를 획득하세요.',
  },
  general: {
    website: 'https://www.thebrandusa.com/',
    forgot: '비밀번호를 잊으셨나요?',
    next: '다음',
    yes: '예',
    no: '아니오',
    previous: '이전',
    submit: '제출',
    register: '가입',
    back: '뒤로',
    close: '닫기',
    page: '페이지',
    search: '검색',
    logIn: '로그인',
    logOut: '로그아웃',
    viewItem: '{type} 보기',
    imageNotFound: '이미지를 찾을 수 없음',
    noResultsFor: '다음에 대한 결과를 찾을 수 없음: {{query}}',
    noFavorites: '즐겨찾기가 없습니다.',
    noMessages: '수신하신 메시지가 없습니다.',
    resultsFor: '다음에 대한 결과: {{query}}',
    showAll: '모두 보기',
    connectionError: '연결 에러',
    alreadyExists: '이미 존재함',
    pageNotFound: '404 페이지를 찾을 수 없음!',
    oops: '죄송합니다.',
    overview: '개요로 돌아가기',
    complete: '계속',
    courseComplete: '챕터 완료!',
    chapterComplete: '챕터를 완료하셨습니다!',
    message: '({count})건의 메시지',
    messagePlural: '({count})건의 메시지',
  },
  itemTypes: {
    image: '이미지',
    brochure: '컬렉션',
    layout: '레이아웃',
    web: '웹사이트',
    pdf: 'PDF',
    carousel: '컬렉션',
  },
  questions: {
    dials: '다이얼을 돌려 답을 맞추세요.',
    fitb: '빈칸을 채우세요.',
    flip: '숫자를 변경해 답을 맞추세요.',
    multipleChoice: '올바른 답을 고르세요.',
    slider: '슬라이더를 사용해 올바른 답을 고르세요.',
    map: '지도 위에서 올바른 위치를 탭해 질문에 답하세요.',
    dropdown: '답을 고르세요.',
    true: '진실',
    false: '거짓',
  },
  reportCard: {
    download: '다운로드',
    email: '이메일',
    print: '인쇄',
  },
  cookies: {
    consent: '동의',
    optout: '수신 거부',
    settings: '개인 정보 보호 설정',
    message:
      '개인 정보 보호 기본 설정에 대해 제공하신 정보가 없습니다! 그래도 괜찮지만, Sales Companion을 통해 최고의 경험을 제공해드리고자 합니다.',
    disabled: '쿠키 사용을 차단하신 것 같습니다.',
    use: '{{appName}} 앱은 최고의 경험을 제공하기 위해 쿠키를 사용합니다.',
    details: '쿠키는 어디에 사용되나요?',
    enable: '쿠키를 사용하는 방법을 보시려면 {{here}}을(를) 확인하세요.',
    here: '여기',
  },
  notLoggedIn: {
    super: '로그인하지 않음',
    title: '이 콘텐츠를 보려면 로그인하셔야 합니다.',
    guest: '손님',
  },
  demo: {
    message: '이 웹사이트는 최종 제품의 데모 버전입니다. 현재 개발 중에 있으며 최종 제품이 아닙니다.',
    consent: '알겠습니다!',
  },
  share: {
    header: '이 리소스를 좋아하는 SNS에 공유하세요!',
    download: '다운로드',
    email: '이메일',
  },
  breadCrumbs: {
    page: '페이지',
  },
  storeButtons: {
    title: '모바일 기기에 앱 다운받기',
  },
  onMobile: {
    header: '모바일 기기로 {appName} 앱에 접근하려고 하시는 것 같습니다',
    body: '이 프로그램을 다운로드하려면 앱 스토어를 열고 {appName} 앱을 검색하거나 다음 버튼 중 하나를 클릭하세요',
    benefits: {
      1: '이동 중에도 배우고, 홍보하고, 영업하세요.',
      2: '다양한 기기에 걸쳐 멀티 미디어 트레이닝 가능',
      3: '완료 인증서 제공',
      4: '체험 및 파트너 배지 제공',
      5: '공유 가능한 홍보 자료',
      6: '24시간 영업 리소스 사용 가능',
      7: '트레이닝 보상',
      header: '다음을 제공해드립니다.',
    },
  },
  custom: {
    splitUsers: '회원 종류',
    brandAmbassador: '브랜드 앰버서더',
    travelPro: '여행 전문가',
  },
  rewards: {
    menu: {
      home: '보상\n홈',
      achievements: '훈련\n성과',
      bookings: '배지\n인센티브',
      form: '예약\n제출',
    },
    rewards: '리워드',
    title: '리워드 앤 실적 센터에 오신 것을 환영합니다.',
    subheader: '트레이닝 실적과 인센티브를 추적하고 공유하세요.',
    button: '내 예약 제출',
    viewAllBookings: '예약',
    viewDashboard: '포인트 대시보드',
    viewRewards: '소개',
    overview: {
      valid: '*입력하신 예약은 클라이언트의 여행이 완료된 다음에만 유효합니다.',
    },
    home: {
      entries: '현재 입력 내역',
      trainingAchievements: '트레이닝 실적',
      trainingAchievementsText:
        '이 페이지에서 내 트레이닝 진행 상황, 인증서, 상으로 된 리워드를 확인하세요. 미국 전문가 학위와 경험 및 파트너 특화 영역에서 획득한 배지를 다운로드 및 공유할 수도 있습니다.',
      bookingContests: '인센티브 대시보드',
      bookingContestsText: '인센티브 대시보드에서 현재 인센티브 프로그램을 쉽게 추적하고 관리하세요. ',
      submitBooking: '예약 제출',
      submitBookingText: '예약 인센티브에 포함시킬 예약을 제출하는 곳입니다.',
      currentContest: '현재 인센티브',
      noContests: '현재 배지 인센티브가 없습니다.',
      ContestEndDate: '인센티브 종료 날짜:',
      ContestDetails: '인센티브 상세 정보',
      ContestSeeProgram: '프로그램',
      ContestTerms: '이용 약관',
      ContestForDetails: '에서 자세한 내용을 확인하세요.',
      ContestPartnerLink: '파트너로 이동',
      ContestLink: '링크로 이동',
    },
    bookingsView: {
      title: '예약',
      infoMessage:
        '위의 버튼을 사용하여 정렬하고 제출 세부 정보를 관리하려면 아무 기록이나 클릭하세요. 보류 중인 모든 항목은 72시간 이내에 확인됩니다.',
    },
    leaderboardScreen: {
      prizes: '상',
      tAndC: '이용 약관이 적용됩니다.*',
    },
    dashboardView: {
      title: '인센티브 대시보드',
      subtitle: '여기에서 인센티브 활동을 추적하세요.',
      badge: '배지 인센티브',
      activity: '예약 인센티브',
      manage: '예약 관리',
      manageSub: '아래에서 현재 예약을 추적하거나 드롭다운을 사용하여 보관된 예약을 확인하세요.',
      noBadgeIncentives: '현재 배지 인센티브가 없습니다.',
      noBookings: '표시할 기록이 없습니다.',
      state: {
        approvedEntries: '승인된 항목',
        pendingEntries: '보류 중인 항목',
        declinedEntries: '거부된 항목',
        viewAll: '모두 보기',
      },
      currentYear: '현재 연도',
      archivedBookings: '보관된 예약',
    },
    bookingForm: {
      title: 'USA 예약 크레딧 양식',
      subTitle: '예약 정보를 입력하세요.',
      required: '*필수 입력 사항',
      email: '여행사 직원 이메일',
      agentFirstName: '여행사 직원 이름',
      agentLastName: '여행사 직원 성',
      company: '여행사/회사명',
      iata: 'IATA/CLIA 번호',
      stateProvince: '주/도',
      postalCode: '우편번호',
      country: '국가',
      city: '도시',
      birthday: '생일',
      type: '고객 여행 유형',
      source: '예약 방법',
      tourOperator: '투어 업체',
      firstName: '고객 이름',
      lastName: '고객 성',
      confirmNumber: '예약 확인 번호/PNR 번호',
      ticketNumber: '티켓 번호',
      file: 'RezSnap™ 증빙 업로드 ',
      arrivalDate: '여행지 도착 날짜',
      departureDate: '여행지 출발 날짜',
      brand: '예약한 브랜드',
      lengthOfStay: '숙박 기간',
      cost: '예약 총 비용',
      rooms: '객실 수',
      airline: '항공사/운송사(2자리 숫자 코드)',
      gateway: '출발 관문(3자리 문자 공항 코드)',
      destination: '도착지/섬(3자리 문자 공항 코드)',
      disclaimer: '*필수 입력 사항',
      button: '내 예약 제출',
      sub: '내 정보',
      sub2: '예약 정보',
      travelDepartureDate: '여행지 출발 날짜',
      travelReturnDate: '여행지 귀국 날짜',
      flightNumber: '미국행 항공 번호',
      numberOfTravelers: '동행 여행객 수',
      edit: '내 정보 편집',
      fileUploaded: '파일이 성공적으로 업로드되었습니다.',
      select: '아래에서 옵션 선택',
      drag: '파일을 여기로 끌어다 놓거나 클릭하여 파일을 선택합니다.',
      fileType: '(.jpeg, .png 및 .pdf 파일 하나만 허용됩니다. 최대 파일 크기는 100MB입니다.)',
      maxSize: '최대 파일 사이즈는 100mb입니다.',
    },
    TermsAndConditions: {
      title: '이용 약관',
      subTitle: '전문가 분기별 리워드',
      body1:
        '모든 게시물은 게시한 각 예약에 해당하는 영업 문서의 대차일치 증빙을 함께 첨부해야 합니다. 수상자는 목록에 등재된 각 예약에 해당하는 영업 문서의 인증된 증빙을 총합하여 이를 바탕으로 선정됩니다. 리워드 대상이 되는 게시물은 반드시 모든 USA 디스커버리 프로그램 규칙에 따라야 합니다.',
      body2:
        '대상이 되기 위해서는 미국에 거주하거나, Brand USA에 소속되고 거주하는 주, 도, 지역에서 성인인 연령이어야 합니다. 투어 업체 직원에게는 수상 자격이 주어지지 않으며, 추가 상의 수상자로 고려되지 않습니다. 퀘벡주 거주자에게는 수상 자격이 주어지지 않으며, 추가 상의 수상자로 고려되지 않습니다.',
      body3:
        '리워드 지급 시 소매점/자택 기반 여행 안내사임을 증명하는 자료를 요구할 수 있습니다. 획득 가능한 리워드는 프로그램의 과정 중에 변경될 수 있습니다.',
      body4: '프라이버시 및 개인 정보의 사용',
      body5:
        '참여하는 대리인은 (1) 리워드 지급자에게 이름, 도시, 주, 도, 우편 번호, 성인 연령 인증, 전화 번호 및 주소를 연락 및 수상자 발표에 포함하나 이에 국한되지 않는 목적으로 사용할 권리를 부여하고, (2) 수상자에게 상과 관련된 홍보의 목적으로 개인 정보를 알려진 모든 미디어 또는 향후 개발될 모든 미디어에 개인 정보를 사용할 권리를 부여하고, (3) 상기 (1) 및 (2)에 나열된 활동과 관련해 수상자가 개인 정보를 제3자 대리인 및 서비스 제공업체에 공개할 수 있다는 사실을 인지합니다.',
      button: '랜딩으로 돌아가기',
    },
    thankYouPage: {
      thanks: '감사합니다.',
      congrats: '축하합니다! ',
      body: '예약이 접수되어 인증을 위해 캠페인 관리자에게 전송되었습니다.',
      link: '수상하기 위해서는 반드시 USA 디스커버리 프로그램 기초 과정을 완료한 상태여야 합니다.',
    },
  },
  facts: {
    title: '알고 계셨나요?',
  },
  badgeView: {
    other: '지역 파트너',
    unlock: '배지를 받기 위해 교육 항목을 완료하기 시작하세요',
    title: '훈련 성과',
    subtitle:
      '당신의 성과 대시보드에 오신 것을 환영합니다, 여기서 당신은 당신의 디플로마와 전문화 배지를 보고, 추적하고, 다운로드할 수 있습니다.',
    viewBadge: '상태 보기',
    badgeDisplayTitle: '메탈릭 보상 상태',
    badgeAchievement: '당신은 {rank} 상태에 도달했습니다! 상태를 보고 공유하려면 오른쪽 아이콘을 클릭하세요.',
    badgesCompleteTitle: '당신의 전문화 배지',
    badgesCompleteSubtitle: '배지를 보고, 저장하고, 공유하기 위해 아이콘을 클릭하세요.',
    badgesIncompleteSubtitle: '이 장들을 완성함으로써 더 많은 배지를 획득하세요.',
    bronze: '브론즈',
    silver: '실버',
    gold: '골드',
    platinum: '플래티넘',
    diploma: '디플로마',
    experiencesBadgesSectionTitle: '익스피리언스 배지',
    itinerariesBadgesSectionTitle: '여정 배지',
    partnerSpecializationBadgesSectionTitle: '파트너 스페셜라이제이션 배지',
    complete: '완료됨',
  },
  missing: {
    discover: '발견하다',
    pacific: '태평양',
    west: '서부',
    southwest: '남서부',
    midwest: '중서부',
    south: '남동부',
    northeast: '북동부',
    territories: '영토',
    shoppingAttractions: '쇼핑 & 명소',
    gettingAround: '이동 수단',
    regionalPartners: '지역 파트너',
    greatOutdoors: '대자연',
    winterSports: '겨울 스포츠',
    coastalEscapes: '해안 탈출',
    flyDrive: '플라이-드라이브',
    foodDrink: '음식 & 음료',
    luxury: '럭셔리',
    musicCultureHeritage: '음악, 문화 & 유산',
    nationalParks: '국립 공원',
    regionMap: '지역 지도',
    videos: '비디오',
    images: '이미지',
    incentives: '인센티브',
    southeast: '남동부',
  },
  searchModal: {
    search: '검색',
    subtitle: '모든 콘텐츠 검색',
    pages: 'USA 디스커버리 프로그램',
    partnerPages: '파트너 프로그램',
    salesCompanion: '세일즈 컴패니언 항목',
    exhibitionTiles: '파트너 쇼케이스',
    noResults: '결과를 찾을 수 없습니다...',
  },
};
